import { render, staticRenderFns } from "./EditActor.vue?vue&type=template&id=6b46610e&scoped=true&"
import script from "./EditActor.vue?vue&type=script&lang=js&"
export * from "./EditActor.vue?vue&type=script&lang=js&"
import style0 from "./EditActor.vue?vue&type=style&index=0&id=6b46610e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b46610e",
  null
  
)

export default component.exports